module.exports = __webpack_public_path__ + "img/ch1video.2198e736.png";